export class Sprite {
    constructor({position, velocity, image, frames = {max: 1}, sprites = {}, scale = 1}) {
        this.position = position;
        this.velocity = velocity;
        this.image = image;
        this.frames = {...frames, val: 0, elapsed: 0};
        this.moving = false;
        this.sprites = sprites;
        this.scale = scale;

        this.image.onload = () => {
            this.width = this.image.width / this.frames.max;
            this.height = this.image.height;
        }
    }

    draw(ctx) {
        const scaledWidth = (this.image.width/this.frames.max) * this.scale;
        const scaledHeight = this.image.height * this.scale;
        
        ctx.drawImage(
            this.image,
            this.frames.val * this.width,
            0,
            this.image.width/this.frames.max,
            this.image.height, 
            this.position.x ,
            this.position.y,
            scaledWidth,
            scaledHeight
        );

        if(!this.moving) return;

        if (this.frames.max > 1) {
            this.frames.elapsed++;
        }
        if (this.frames.elapsed % 10 === 0) {
            if (this.frames.val < this.frames.max - 1) {
                this.frames.val++;
            } else {
                this.frames.val = 0;
            }
        }
    }

    switchSprite(name) {
        if (this.image === this.sprites[name]) return;
        this.image = this.sprites[name];
        this.frames.val = 0;
        this.image.onload = () => {
            this.width = this.image.width / this.frames.max;
            this.height = this.image.height;
        }
    }
}

// Based on the zoom level, the collision block should be 36x36 or 48x48

export class CollisionBlock {
    static width = 36;
    static height = 36;
    constructor({position}) {
        this.position = position;
        this.width = 36;
        this.height = 36;
    }
    draw(ctx) {
        ctx.fillStyle = 'rgba(255, 0, 0, 0)';
        ctx.fillRect(this.position.x, this.position.y, this.width, this.height);
    }
}